// removed by extract-text-webpack-plugin
module.exports = {"link":"index-link-2ulTf","opacity":"index-opacity-cxnrM","brightness":"index-brightness-3uztJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/link/index.less
// module id = 1038
// module chunks = 0 1